import React from 'react'

const SearchCloseIcon = props => {
  return (
    <svg className={props.className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
      <path d="M8.41,7l5.3,5.29a1,1,0,0,1-1.42,1.42L7,8.41l-5.29,5.3A1,1,0,0,1,.29,12.29L5.59,7,.29,1.71A1,1,0,0,1,1.71.29L7,5.59,12.29.29a1,1,0,1,1,1.42,1.42Z" transform="translate(0 0)"/>
    </svg>
  )
}

export default SearchCloseIcon


// WEBPACK FOOTER //
// ./src/assets/icons/close-icon.js